import { render, staticRenderFns } from "./StockPhotos.vue?vue&type=template&id=639a9ed0&"
import script from "./StockPhotos.vue?vue&type=script&lang=js&"
export * from "./StockPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports